import { ReservationOccasion } from '../../../../../services/exports/Constants';

export default {
  updated_details: 'Detalii actualizate',
  previous_details: 'Detalii anterioare',
  fields: {
    datetime: 'Dată:',
    email: 'Email:',
    phone_number: 'Număr de telefon:',
    customer: 'Client:',
    source: 'Sursă:',
    guests: 'Oaspeți:',
    comment: 'Comentariu:',
    confirmed_at: 'Confirmat la:',
    status: 'Status:',
    occasion: 'Ocazie:',
    created_at: 'Creat la:',
  },
  status: {
    confirmed: 'Confirmat',
    pending: 'În așteptarea aprobării',
    canceled: 'Anulat',
    canceled_by_customer: 'Anulat de client',
    rejected: 'Respins',
    removed: 'Eliminat',
  },
  buttons: {
    confirm: 'Confirmă',
    reject: 'Respinge',
    cancel: 'Anulează',
    edit: 'Editează',
    remove: 'Elimină',
  },
  occasion: {
    [ReservationOccasion.Birthday]: 'Zi de naștere',
    [ReservationOccasion.Anniversary]: 'Aniversare',
    [ReservationOccasion.Date]: 'Dată',
    [ReservationOccasion.SpecialOccasion]: 'Ocazie Specială',
    [ReservationOccasion.BusinessMeal]: 'Masă de Afaceri',
  },
  remove_reservation_modal: {
    title: 'Sigur doriți să eliminați rezervarea?',
    buttons: {
      remove: 'Elimină',
      cancel: 'Anulează',
    },
  },
  response_messages: {
    success: 'Starea rezervării a fost actualizată cu succes. Clientul a fost notificat.',
    error: 'Actualizarea stării rezervării a eșuat. Vă rugăm să încercați din nou.',
  },
};
